'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _quiverAssets = require('@surfline/quiver-assets');

var _quiverAssets2 = _interopRequireDefault(_quiverAssets);

var _CamOverlay = require('../CamOverlay');

var _CamOverlay2 = _interopRequireDefault(_CamOverlay);

var _CamRewind = require('../CamRewind');

var _CamRewind2 = _interopRequireDefault(_CamRewind);

var _AspectRatioContent = require('../AspectRatioContent');

var _AspectRatioContent2 = _interopRequireDefault(_AspectRatioContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamAdblockUpsell = function CamAdblockUpsell(_ref) {
  var href = _ref.href,
      rewindUrl = _ref.rewindUrl,
      onClick = _ref.onClick,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cam-adblock' },
    rewindUrl ? _react2.default.createElement(_CamRewind2.default, { href: rewindUrl }) : null,
    _react2.default.createElement(
      _AspectRatioContent2.default,
      null,
      _react2.default.createElement(_CamOverlay2.default, { backgroundImage: 'url(' + _quiverAssets2.default + '/backgrounds/cam-down-bg-image.png)' }),
      _react2.default.createElement(
        'div',
        { className: 'quiver-cam-adblock-upsell__message' },
        _react2.default.createElement(
          'div',
          { className: 'quiver-cam-adblock-upsell__message__header' },
          text.disableText
        ),
        _react2.default.createElement(
          'div',
          { className: 'quiver-cam-adblock-upsell__message__subtext' },
          _react2.default.createElement(
            'div',
            { className: 'quiver-cam-adblock-upsell__message__or' },
            _react2.default.createElement(
              'span',
              null,
              text.orText
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            text.upsellText
          )
        ),
        _react2.default.createElement(
          'a',
          { href: href, onClick: onClick },
          _react2.default.createElement(
            'button',
            null,
            text.linkText
          )
        )
      )
    )
  );
};

CamAdblockUpsell.propTypes = {
  href: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  text: _propTypes2.default.shape({
    disableText: _propTypes2.default.string,
    orText: _propTypes2.default.string,
    upsellText: _propTypes2.default.string,
    linkText: _propTypes2.default.string
  }),
  rewindUrl: _propTypes2.default.string
};

CamAdblockUpsell.defaultProps = {
  href: null,
  onClick: null,
  text: {
    disableText: 'Please disable your ad blocker in order to view this Surfline cam.',
    orText: 'or',
    upsellText: 'For a completely ad-free cam experience',
    linkText: 'Upgrade to Premium'
  },
  rewindUrl: null
};

exports.default = CamAdblockUpsell;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamAdBlock/CamAdBlock.js
// module id = 529
// module chunks = 11